"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'refundOrderRebates',
  props: {
    dialogVisibleOrderRebates: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    refundOrderNo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pram: {
        returnType: 1,
        refundOrderNo: '',
        refundAmount: null // 指定退款金额
      },
      dialogVisible: this.dialogVisibleOrderRebates,
      refundPrice: 0,
      // 预计退款金额
      loading: false,
      submitLoading: false,
      refundOrderInfo: null // 退款单信息
    };
  },
  watch: {
    dialogVisibleOrderRebates: {
      handler: function handler(val) {
        this.dialogVisible = val;
      },
      deep: true
    },
    'pram.returnType': {
      handler: function handler(val) {
        // 切换退款类型时清空指定金额
        if (val === 2) {
          this.pram.refundAmount = null;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.getRefundOrderDetail();
  },
  methods: {
    // 获取退款订单详情
    getRefundOrderDetail: function getRefundOrderDetail() {
      var _this = this;
      this.loading = true;
      (0, _order.refundOrderDetailApi)(this.refundOrderNo).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                console.log('获取退款订单信息', res);
                _this.refundOrderInfo = res;
                // 设置预计退款金额
                _this.refundPrice = res.refundPrice || 0;
                _this.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this.loading = false;
      });
    },
    // 验证退款金额
    validateRefundAmount: function validateRefundAmount(rule, value, callback) {
      var numValue = parseFloat(value);
      if (!value || isNaN(numValue)) {
        callback(new Error('请输入退款金额'));
      } else if (numValue < 0.01) {
        callback(new Error('退款金额最低为0.01元'));
      } else if (numValue > this.refundPrice) {
        callback(new Error('退款金额不能大于预计退款金额'));
      } else {
        callback();
      }
    },
    // 处理金额输入
    handleAmountInput: function handleAmountInput(value) {
      // 只允许输入数字和小数点
      this.pram.refundAmount = value.replace(/[^\d.]/g, '').replace(/^\./g, '') // 不能以小数点开头
      .replace(/\.{2,}/g, '.') // 只保留一个小数点
      .replace(/^(\d+)\.(\d\d).*$/, '$1.$2'); // 最多保留两位小数
    },
    // 提交
    handlerSubmit: function handlerSubmit() {
      var _this2 = this;
      this.$refs.pram.validate(function (valid) {
        if (valid) {
          var refundAmount = parseFloat(_this2.pram.refundAmount);
          // 指定退款需要验证金额
          if (_this2.pram.returnType === 2 && (!_this2.pram.refundAmount || isNaN(refundAmount) || refundAmount < 0.01)) {
            return _this2.$message.warning('请输入有效的退款金额（最低0.01元）！');
          }
          _this2.$modalSure('确认退款').then(function () {
            _this2.submitLoading = true;

            // 准备提交数据
            var submitData = {
              auditType: 'success',
              refundOrderNo: _this2.refundOrderNo,
              refundSpecifyStatus: _this2.pram.returnType === 2 // 是否指定退款
            };

            // 如果是指定退款，传递指定退款金额
            if (_this2.pram.returnType === 2) {
              submitData.specifyRefundPrice = parseFloat(_this2.pram.refundAmount);
            }
            console.log('提交退款数据', submitData);

            // 调用审核通过接口
            (0, _order.orderAuditApi)(submitData).then(function () {
              _this2.submitLoading = false;
              _this2.$message.success('退款成功');
              _this2.$emit('handlerSuccessSubmit');
            }).catch(function () {
              _this2.submitLoading = false;
            });
          }).catch(function () {
            // 用户取消
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    handlerClose: function handlerClose() {
      this.$emit('handlerSuccessClose');
    }
  }
};